import { lazy } from 'react';
export var UsersPageAsync = lazy(function () { return import('./UsersPage'); });
